module.exports = __webpack_public_path__ + "static/media/moneyorder.7a20a41c.png";